import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { HotelOverview } from './pages/HotelOverview';
import { HotelDetail } from './pages/HotelDetail';
import { Templates } from './pages/Templates';
import { Admin } from './pages/Admin';
import { Login } from './pages/Login';
import { AuthGuard } from './components/AuthGuard';
import { UserProvider } from './contexts/UserContext';
import { NoAssignedHotels } from './pages/NoAssignedHotels';
import { WidgetCustomizer } from './pages/WidgetCustomizer';
import { Info } from './pages/Info';
import { MeetScout } from './pages/MeetScout';
import { Notifications } from './pages/Notifications';

function App() {
  return (
    <UserProvider>
      <Router>
        <Routes>
          {/* Public route */}
          <Route path="/login" element={<Login />} />
          
          {/* No Assigned Hotels - minimal layout (no sidebar) */}
          <Route path="/no-access" element={
            <AuthGuard>
              <Layout hideSidebar>
                <NoAssignedHotels />
              </Layout>
            </AuthGuard>
          } />
          
          {/* Protected routes */}
          <Route path="/" element={
            <AuthGuard>
              <Layout>
                <HotelOverview />
              </Layout>
            </AuthGuard>
          } />
          <Route path="/dashboard" element={
            <AuthGuard>
              <Layout>
                <HotelOverview />
              </Layout>
            </AuthGuard>
          } />
          <Route path="/hotels" element={
            <AuthGuard>
              <Layout>
                <HotelOverview />
              </Layout>
            </AuthGuard>
          } />
          <Route path="/hotel/:hotelSlug" element={
            <AuthGuard>
              <Layout>
                <HotelDetail />
              </Layout>
            </AuthGuard>
          } />
          <Route path="/templates" element={
            <AuthGuard requiredRole="admin">
              <Layout>
                <Templates />
              </Layout>
            </AuthGuard>
          } />
          <Route path="/info" element={
            <AuthGuard>
              <Layout>
                <Info />
              </Layout>
            </AuthGuard>
          } />
          <Route path="/meet-scout" element={
            <AuthGuard>
              <Layout>
                <MeetScout />
              </Layout>
            </AuthGuard>
          } />
          <Route path="/admin" element={
            <AuthGuard requiredRole="admin">
              <Layout>
                <Admin />
              </Layout>
            </AuthGuard>
          } />
          <Route path="/notifications" element={
            <AuthGuard requiredRole="admin">
              <Layout>
                <Notifications />
              </Layout>
            </AuthGuard>
          } />
          <Route path="/widget-customizer" element={
            <AuthGuard>
              <Layout>
                <WidgetCustomizer />
              </Layout>
            </AuthGuard>
          } />
        </Routes>
      </Router>
    </UserProvider>
  );
}

export default App;
